import { formatFileSize } from '../../lib/dateUtils';
import type { FileStats } from '../../hooks/useFiles';

interface Props {
  totalCount: number;
  stats: FileStats;
}

export function FileStatsCards({ totalCount, stats }: Props) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <div className="bg-white rounded-lg shadow-md p-3 md:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-steel">Total Files</p>
            <p className="text-xl md:text-2xl font-bold text-navy mt-0.5">{totalCount}</p>
          </div>
          <div className="text-2xl md:text-3xl">📎</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-3 md:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-steel">Audio</p>
            <p className="text-xl md:text-2xl font-bold text-navy mt-0.5">{stats.audioCount}</p>
          </div>
          <div className="text-2xl md:text-3xl">🎵</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-3 md:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-steel">Transcripts</p>
            <p className="text-xl md:text-2xl font-bold text-navy mt-0.5">{stats.transcriptCount}</p>
          </div>
          <div className="text-2xl md:text-3xl">📄</div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-md p-3 md:p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-medium text-steel">Storage</p>
            <p className="text-xl md:text-2xl font-bold text-navy mt-0.5">{formatFileSize(stats.totalBytes)}</p>
          </div>
          <div className="text-2xl md:text-3xl">💾</div>
        </div>
      </div>
    </div>
  );
}
